import React from 'react';
import PropTypes from 'prop-types';

import { createPortal } from 'react-dom';

// Renders the dropdown menu into document.body so it can't be clipped by an
// ancestor. Safari clips even position:fixed descendants against an ancestor
// that has `overflow` + `border-radius` (e.g. the `.table-container` wrapping
// the voucher worksheet tables), which cut off the kebab menu options and
// forced users to scroll inside the table to reach them.
//
// react-bootstrap's Dropdown.Menu has no built-in portal/container option, so
// we swap the menu's root element for this via the `as` prop. Popper still
// positions the menu correctly - it works off the toggle/menu refs regardless
// of where the menu lives in the DOM.
const DropdownPortalMenu = React.forwardRef(function DropdownPortalMenu(
  // `show`, `close` and `align` are injected by react-bootstrap only because
  // the menu root is a component rather than a string. They aren't valid DOM
  // attributes, so pull them out before spreading the rest onto the div.
  // eslint-disable-next-line no-unused-vars
  { align, children, close, show, ...props },
  ref,
) {
  return createPortal(
    <div ref={ref} {...props}>
      {children}
    </div>,
    document.body,
  );
});

DropdownPortalMenu.propTypes = {
  align: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.node,
  close: PropTypes.func,
  show: PropTypes.bool,
};

export default DropdownPortalMenu;
